export default __webpack_public_path__ + "static/media/noodles.39deddf4.jpg";